(function ($, Global) {
    var plausible = Global.plausible || function () { };
    var urlParams = new UrlParams();

    var ModalCookieConsentSettings = function (selector) {
        this.selector = selector;
        this.$el = $(selector);
        this.cookieManager = new Global.CookieManager();
        this.paramUrl = "cookieSettings";
    };

    ModalCookieConsentSettings.prototype.initEvents = function () {
        this.publishers();
    }

    ModalCookieConsentSettings.prototype.publishers = function () {
        var self = this
        $(document).ready(function () {
            self.onReady()
        });

        $(document).on('click', this.selector + ' .btn-accept-all', function () {
            self.dispatchEvent("ParametrageToutAccepter", "Cookie - Parametrage - tout accepter")
            self.cookieManager.approve(self.cookieManager.allServices);
            $('.bouton-livechat, .bouton-livechat-description').hide();
        });
        $(document).on('click', this.selector + ' .btn-accept', function () {
            self.dispatchEvent("ParametrageSelectionAccepter", "Cookie - Parametrage - accepter selection")
            var services = self.getActivateServices();
            self.cookieManager.approve(services);
            $('.bouton-livechat, .bouton-livechat-description').hide();
        });
        $(document).on('click', this.selector + ' .btn-refuse', function () {
            self.dispatchEvent("ParametrageToutRefuser", "Cookie - Parametrage - tout refuser")
            var services = self.cookieManager.servicesActivate();
            self.cookieManager.approve(services.filter(function (s) { return s === 'oneSignal' }));
        });
        $(document).on('show.bs.modal', this.selector, function () {
            var services = self.cookieManager.servicesActivate();
            if (!services) return;
            self.handleServicesChecked(services);
        });
        $(document).on('shown.bs.modal', this.selector, function () {
            self.dispatchEvent("AffichageParametres", "Cookie - Parametrage - affichage fenetre")
            $('body').addClass('modal-open');
        });
    };

    ModalCookieConsentSettings.prototype.onReady = function () {
        var self = this
        setTimeout(function () {
            if (!urlParams.getParam(self.paramUrl) || $('.modal.in').exists()) return;

            self.$el.modal('show');
        }, 600)
    }

    ModalCookieConsentSettings.prototype.getActivateServices = function () {
        var services = this.cookieManager.servicesActivate();
        services = services.filter(function (s) { return s === 'oneSignal' })

        if (this.$el.find('#analyticsService').is(':checked')) services.push('analytics');
        if (this.$el.find('#socialService').is(':checked')) services.push('social');
        if (this.$el.find('#supportService').is(':checked')) services.push('liveChat');

        return services;
    }

    ModalCookieConsentSettings.prototype.handleServicesChecked = function (services) {
        var self = this
        for (var i = 0; i <= services.length; i++) {
            var checkbox = null;

            if (services[i] === 'analytics') {
                checkbox = self.$el.find('#analyticsService');
            } else if (services[i] === 'twitter' || services[i] === 'social') {
                checkbox = self.$el.find('#socialService');
            } else if (services[i] === 'liveChat') {
                checkbox = self.$el.find('#supportService');
            }

            if (checkbox !== null) {
                checkbox.prop("checked", true);
                checkbox.parent().addClass('check');
            }
        }
    }

    ModalCookieConsentSettings.prototype.dispatchEvent = function (type, label) {
        plausible(label);
        document.dispatchEvent(
            new CustomEvent("EventCookieConsent", {
                detail: {
                    type: type,
                    label: label
                }
            })
        )
    }

    Global.ModalCookieConsentSettings = ModalCookieConsentSettings;
}(jQuery, window));